function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.5 12.8105C13.2722 12.8105 15.5313 10.133 15.5313 6.83848C15.5313 3.54391 13.2722 0.866455 10.5 0.866455C7.72778 0.866455 5.46875 3.54391 5.46875 6.83848C5.46875 10.133 7.73281 12.8105 10.5 12.8105ZM10.5003 2.35946C12.4473 2.35946 14.0221 4.35014 14.0221 6.83848C14.0221 9.32683 12.4473 11.3175 10.5003 11.3175C8.55316 11.3175 6.97838 9.32683 6.97838 6.83848C6.97838 4.35014 8.55316 2.35946 10.5003 2.35946Z",
  fill: "#BBD422"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.1866 12.8142C14.7623 12.7742 14.3839 13.0664 14.3415 13.467C14.299 13.8675 14.6086 14.2247 15.0329 14.2648C17.4157 14.5291 19.2617 16.3571 19.4276 18.6165H1.57244C1.754 16.3637 3.59202 14.5436 5.96707 14.2648C6.39139 14.2247 6.70097 13.8675 6.65854 13.467C6.61611 13.0664 6.23773 12.7742 5.81341 12.8142C5.75707 12.8142 0 13.4331 0 19.337C0 19.7376 0.343976 20.0623 0.768293 20.0623H20.2317C20.656 20.0623 21 19.7376 21 19.337C21 13.4331 15.2429 12.8142 15.1866 12.8142Z",
  fill: "#BBD422"
});

function SvgPerson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.e0beab13.svg";
export { ForwardRef as ReactComponent };